import React from 'react';
import { formatTime } from '../../utils/time';
import LineChart from './LineChart';
const timeFormatter = unixTime => formatTime(unixTime * 1000);

const DateLineChart = ({ data, xAxisLabel, yAxisLabel, xField, ticks, dataFields = ['value'] }) => {
  return (
    <LineChart
      data={data}
      xField={xField}
      xAxisLabel={xAxisLabel}
      yAxisLabel={yAxisLabel}
      dataFields={dataFields}
      xAxisLabelFormatter={timeFormatter}
      ticks={ticks}
    />
  );
};

export default DateLineChart;
